import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveShopTheme, themeCssVars } from '../theme';
import { useI18n } from '../i18n';
import { AccentButton, ShopFooter, SmallCaps } from '../components/ShopChrome';

/**
 * The bare domain root. A shop always lives at /shop/:locationId, so the only useful
 * thing to offer here is the voucher lookup.
 */
const ShopHome: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const theme = resolveShopTheme(null);

  return (
    <div className="flex min-h-screen flex-col" style={themeCssVars(theme)}>
      <main className="mx-auto flex w-full max-w-[560px] flex-1 flex-col justify-center px-5 py-16">
        <SmallCaps theme={theme}>{t('home.eyebrow')}</SmallCaps>
        <h1
          style={{
            margin: '12px 0 8px',
            font: `500 clamp(28px, 6vw, 38px)/1.12 ${theme.fontFamily}`,
            letterSpacing: '-.025em',
            color: theme.ink,
          }}
        >
          {t('home.title')}
        </h1>
        <p style={{ margin: '0 0 28px', font: `400 16px/1.65 ${theme.fontFamily}`, color: theme.body }}>
          {t('home.body')}
        </p>
        <div>
          <AccentButton theme={theme} onClick={() => navigate('/voucher')}>
            {t('voucher.check_label')}
          </AccentButton>
        </div>
      </main>
      <ShopFooter theme={theme} />
    </div>
  );
};

export default ShopHome;
